import DedicatedStoreFooter from "../DedicatedStoreFooter";
import type { PublicCompany } from "@/types/store";
import styles from "./services.module.css";

type Props = {
  company: PublicCompany;
  primaryColor?: string;
  instagramUrl: string;
  facebookUrl: string;
  hasProducts: boolean;
  hasAbout: boolean;
};

export default function ServicesFooter({
  company,
  primaryColor = "",
  instagramUrl,
  facebookUrl,
  hasProducts,
  hasAbout,
}: Props) {
  return (
    <DedicatedStoreFooter
      company={company}
      primaryColor={primaryColor}
      fallbackColor="#0f172a"
      containerClassName={styles.container}
      instagramUrl={instagramUrl}
      facebookUrl={facebookUrl}
      showCashPayment
      institutional={
        <>
          <a href="#inicio">Início</a>
          <a href="#servicos">Serviços</a>

          {hasProducts && <a href="#produtos">Produtos</a>}

          {hasAbout && <a href="#sobre">Sobre a empresa</a>}

          <a href="#avaliacoes">Avaliações</a>
          <a href="#contato">Contato</a>
        </>
      }
      servicesLabel="Atendimento"
      services={
        <>
          <a href="#servicos">Conheça nossos serviços</a>
          <a href="#todos-servicos">Todos os serviços</a>

          {hasProducts && <a href="#produtos">Produtos disponíveis</a>}
        </>
      }
    />
  );
}
